import createAttachmentService from '@espoon-voltti/react-voltti/components/attachment-selector/domain/attachment-service'
import { api } from '@espoon-voltti/react-voltti/components/attachment-selector/domain/attachment-api'

import { apiBaseUrl } from './api/utils'

export const attachmentApiUrl = `${apiBaseUrl}/attachments`
export const attachmentAuthProfile = 'nuora'

export const attachmentService = createAttachmentService(
  api(attachmentAuthProfile, attachmentApiUrl)
)
